import { Link } from "react-router-dom";
import { useObsessedRightNow } from "../hooks/useObsessedRightNow";
import { getListingUrl } from "../../../utils/url.utils";
import { LazyLoadImage } from "react-lazy-load-image-component";

function ObsessedRightNow() {
  const { items: obsessedItems, loading } = useObsessedRightNow();

  if (loading || !obsessedItems.length) return null;

  return (
    <section className="obsessed-section">
      <h2>
        <em>Obsessed</em>{" "}
        <span className="track_obsd">Right Now</span>
      </h2>

      <div className="obsessed-grid">
        {obsessedItems.map((item) => (
          <div className="obsessed-card" key={item.id}>
            <Link to={getListingUrl(item.url)} target="_blank">
              <LazyLoadImage
                className="img_right_now"
                src={item.src}
                alt={item.title}
                loading="lazy"
                effect="blur"
              />
              <p className="obs_track_text">
                {item.title.toLowerCase()}
              </p>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ObsessedRightNow;